<template>
  <el-table-column
    prop="out_date"
    sortable
    label="Kikerülés dátum"
    min-width="150px"
  >
    <template slot-scope="scope">
      {{ scope.row.out_date | date }}
    </template>
  </el-table-column>
</template>

<script>
  export default {
    propName: 'out_date',
  };
</script>
